// TODO: Cut down userTour dependencies outside trackIQ and move this code to trackIQ folder
import { createSelector } from 'reselect';
import {
    clientSelector,
    userIdSelector,
    selectedDateSelector,
    shiftIdSelector,
    selectedTourIdSelector
} from './queryParamsSelectors';
import Immutable from 'immutable';
import _ from 'lodash';

import { VisitStatusEnum } from 'common/enums/VisitEnums';
import { TourStatusEnum } from 'common/enums/TourEnum';

export const PathTypeEnum = {
    Planned: 'PLANNED',
    Executed: 'EXECUTED'
};

export const COMBINED_TOUR_ID = 'combined-tour';

export const getAllUserTours = createSelector(
    [
        clientSelector,
        userIdSelector,
        selectedDateSelector,
        shiftIdSelector,
        state => state.userTour
    ],
    (clientId, userId, date, shift, userTours) => {
        return userTours.getIn([
            'records',
            clientId,
            userId,
            date,
            shift,
            'entity'
        ]);
    }
);

export const isLoadingUserTours = createSelector(
    [
        clientSelector,
        userIdSelector,
        selectedDateSelector,
        shiftIdSelector,
        state => state.userTour
    ],
    (clientId, userId, date, shift, userTours) => {
        return userTours.getIn([
            'records',
            clientId,
            userId,
            date,
            shift,
            'status',
            'isLoadingUserTours'
        ]);
    }
);

export const getUserTourDropDownSource = createSelector(
    [getAllUserTours],
    allTours => {
        if (!allTours) return [];
        let modifiedAllTours = allTours;
        if (allTours.findIndex(tour => tour.get('isMultiDay')) > -1) {
            //if multiday, remove combined tour
            modifiedAllTours = allTours.filter(
                tour => tour.getIn(['tourId', 'tourId']) !== COMBINED_TOUR_ID
            );
        }
        return modifiedAllTours
            .map((tour, index) => {
                const tourId = tour.getIn(['tourId', 'tourId']);
                const tourName = tour.get('tourName');
                return {
                    value: index + 1,
                    tourId,
                    tourName,
                    noOfTasks: tour
                        .get('taskCounts', Immutable.List())
                        .reduce(
                            (previous, countWrapper) =>
                                previous + countWrapper.get('count'),
                            0
                        ),
                    status: tour.get('status')
                };
            })
            .toJS();
    }
);

export const getSelectedTourId = createSelector(
    [getUserTourDropDownSource, selectedTourIdSelector],
    (dropdownTours, selectedTourId) => {
        let newSelectedTourId = selectedTourId;
        if (!newSelectedTourId) {
            if (dropdownTours && dropdownTours.length > 0) {
                var selectedTour = dropdownTours.find(
                    tour =>
                        tour.status === TourStatusEnum.InProgress &&
                        tour.tourId !== COMBINED_TOUR_ID
                );
                if (!selectedTour) {
                    selectedTour = _.findLast(
                        dropdownTours,
                        tour => tour.status === TourStatusEnum.Completed
                    );
                }
                if (!selectedTour) {
                    selectedTour = _.findLast(dropdownTours);
                }
                newSelectedTourId = selectedTour.tourId;
            }
        }
        return newSelectedTourId;
    }
);

export const getSelectedTourIndex = createSelector(
    [getUserTourDropDownSource, getSelectedTourId],
    (dropdownTours, selectedTourId) => {
        if (!dropdownTours) {
            return dropdownTours;
        }
        const tourIndex = dropdownTours.findIndex(
            tour => tour.tourId === selectedTourId
        );
        if (tourIndex < 0) {
            return null;
        }
        return (
            dropdownTours.findIndex(tour => tour.tourId === selectedTourId) + 1
        );
    }
);

export const getSelectedTourDates = createSelector(
    [getAllUserTours, getSelectedTourId],
    (tours, selectedTourId) => {
        if (!tours) {
            return null;
        }
        const [selectedTour] = tours.filter(tour => {
            return tour.getIn(['tourId', 'tourId']) === selectedTourId;
        });
        const tourDates = selectedTour && selectedTour.get('tourDates');
        return tourDates;
    }
);

export const getSelectedTourIsMultiDay = createSelector(
    [getAllUserTours, getSelectedTourId],
    (tours, selectedTourId) => {
        if (!tours) {
            return null;
        }
        const [selectedTour] = tours.filter(tour => {
            return tour.getIn(['tourId', 'tourId']) === selectedTourId;
        });
        const isMultiDay = selectedTour && selectedTour.get('isMultiDay');
        return isMultiDay;
    }
);

export const getSelectedUserTour = createSelector(
    [getAllUserTours, getSelectedTourId],
    (userTours, selectedTourId) => {
        if (userTours)
            return userTours.find(
                tour => tour.getIn(['tourId', 'tourId']) === selectedTourId
            );
        return userTours;
    }
);

export const getAllTaskVisits = createSelector(
    [getSelectedUserTour, isLoadingUserTours],
    (userTour, isLoading) => {
        if (!userTour) {
            if (isLoading) {
                return null;
            } else if (!isLoading) {
                return Immutable.List();
            }
        }
        var allVisits = userTour
            .get('visits')
            .filter(visit => visit.get('visitType') !== 'USER');
        return allVisits;
    }
);

export const getWaitingTaskVisits = createSelector(
    [getAllTaskVisits],
    allUserVisits => {
        if (!allUserVisits) {
            return null;
        }
        return allUserVisits.filter(
            visit => visit.get('taskStatus') === 'WAITING'
        );
    }
);

export const getOngoingTaskVisits = createSelector(
    [getAllTaskVisits],
    allUserVisits => {
        if (!allUserVisits) {
            return null;
        }
        return allUserVisits.filter(
            visit => visit.get('taskStatus') === 'ONGOING'
        );
    }
);

export const getCompletedTaskVisits = createSelector(
    [getAllTaskVisits],
    allUserVisits => {
        if (!allUserVisits) {
            return null;
        }
        return allUserVisits.filter(
            visit => visit.get('taskStatus') === 'COMPLETED'
        );
    }
);

export const getCancelledTaskVisits = createSelector(
    [getAllTaskVisits],
    allUserVisits => {
        if (!allUserVisits) {
            return null;
        }
        return allUserVisits.filter(
            visit => visit.get('taskStatus') === 'CANCELLED'
        );
    }
);

export const getPathTypeToBeShown = createSelector(
    [getAllTaskVisits],
    allTaskVisits => {
        if (!allTaskVisits) {
            return PathTypeEnum.Planned;
        }
        var isTourInProgress = false;
        var visit, visitStatus;
        for (var i = 0; i < allTaskVisits.size; i++) {
            visit = allTaskVisits.get(i);
            visitStatus = visit.get('visitStatus');
            if (
                visitStatus === VisitStatusEnum.Travelling ||
                visitStatus === VisitStatusEnum.Transacting ||
                visitStatus === VisitStatusEnum.Completed ||
                visitStatus === VisitStatusEnum.Cancelled
            ) {
                isTourInProgress = true;
                break;
            }
        }
        if (isTourInProgress) {
            return PathTypeEnum.Executed;
        } else {
            return PathTypeEnum.Planned;
        }
    }
);

export const isTourChecklistLoading = createSelector(
    [
        clientSelector,
        userIdSelector,
        selectedDateSelector,
        shiftIdSelector,
        state => state.userTour
    ],
    (clientId, userId, date, shift, userTours) => {
        return userTours.getIn([
            'records',
            clientId,
            userId,
            date,
            shift,
            'status',
            'isTourChecklistLoading'
        ]);
    }
);
